module.exports = __webpack_public_path__ + "img/icon-openended.86c6fddf.svg";